var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg45Min(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8522 2.27257C17.8522 1.01746 18.8697 0 20.1248 0C21.3799 0 22.3974 1.01746 22.3974 2.27257V2.95044C31.5946 4.0711 38.7188 11.9069 38.7188 21.4067C38.7188 31.6758 30.3941 40.0005 20.125 40.0005C9.85596 40.0005 1.53125 31.6758 1.53125 21.4067C1.53125 17.0583 3.02399 13.0584 5.52499 9.89172L5.19177 9.58264C4.27157 8.7291 4.21753 7.2912 5.07107 6.371C5.9246 5.4508 7.3625 5.39676 8.2827 6.2503L8.75792 6.69109C11.336 4.69673 14.4525 3.36482 17.8522 2.95049V2.27257Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1254 4.8785C23.3943 4.8785 26.5898 5.84784 29.3078 7.66393C32.0258 9.48003 34.1442 12.0613 35.3951 15.0814C36.6461 18.1014 36.9734 21.4246 36.3357 24.6307C35.6979 27.8368 34.1238 30.7817 31.8124 33.0932C29.5009 35.4047 26.5559 36.9788 23.3499 37.6165C20.1438 38.2542 16.8206 37.9269 13.8005 36.676C10.7805 35.425 8.19919 33.3066 6.38309 30.5886C4.56699 27.8707 3.59766 24.6752 3.59766 21.4063L20.1254 21.4063L20.1254 4.8785Z",
    fill: "#C93F37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1232 20.3735C16.5819 18.5914 18.1996 17.2747 20.1249 17.2747C22.4069 17.2747 24.2568 19.1246 24.2568 21.4066C24.2568 23.6886 22.4069 25.5386 20.1249 25.5386C18.1995 25.5386 16.5817 24.2217 16.1231 22.4395L7.23764 22.4395C6.66714 22.4395 6.20466 21.977 6.20466 21.4065C6.20466 20.836 6.66714 20.3735 7.23765 20.3735L16.1232 20.3735Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1249,
    cy: 21.4066,
    r: 1.56259,
    transform: "rotate(-180 20.1249 21.4066)",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg45Min);
export default __webpack_public_path__ + "static/media/45min.a6e800b7f1671cecb221ccf46a362fbb.svg";
export { ForwardRef as ReactComponent };